export default "__VITE_ASSET__CRE9hy10__"